<template>
    <div class="form">
        <el-form style="margin:20px;width:70%;min-width:600px;" label-width="180px">
            <el-form-item class='edit-form' label="销售下单号">
                <span>{{Form.OrderCode}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单号">
                <span>{{Form.SendCode}}</span>
            </el-form-item>
            <!--<el-form-item class='edit-form' label="发货通知单状态">-->
            <!--<span>{{Form.SendStatusName}}</span>-->
            <!--</el-form-item>-->
            <!--<el-form-item class='edit-form' label="要求发货日期">-->
            <!--<span>{{Form.RequireSendDate}}</span>-->
            <!--</el-form-item>-->
            <el-form-item class='edit-form' label="发货状态">
                <span>{{Form.DeliveryStatusName}}</span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="代理商">
                <!--<span>{{Form.AgentName}} {{Form.AgentAddress}} {{Form.AgentTel}}</span>-->
                <span>{{Form.AgentCode}} &nbsp; {{Form.AgentName}} &nbsp; {{Form.AgentAddress}} &nbsp; {{Form.AgentTel}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单下单时间">
                <span>{{Form.SendTime}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="业务员">
                <span>{{Form.SaleEmployeeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="商品" v-show="Form.ListGoods!=''" style="width:900px">
                <el-table :data="Form.ListGoods" border style="width: 100%;  margin-left: 25px;">
                    <el-table-column prop="ProName" label="名称">
                    </el-table-column>
                    <el-table-column prop="ProductNum" label="订单数">
                    </el-table-column>
                    <!-- <el-table-column prop="UnSendNum" label="未通知数">
                                    </el-table-column>-->
                    <el-table-column prop="SendNum" label="通知数">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item class='edit-form' label="赠品" v-show="Form.GiftGoods!=''" style="width:900px">
                <el-table :data="Form.GiftGoods" border style="width: 80%;  margin-left: 25px;">
                    <el-table-column prop="ProName" label="名称">
                    </el-table-column>
                    <el-table-column prop="ProductNum" label="订单数">
                    </el-table-column>
                    <!--<el-table-column prop="UnSendNum" label="未通知数">
                                    </el-table-column>-->
                    <el-table-column prop="SendNum" label="通知数">
                    </el-table-column>
                </el-table>
            </el-form-item>

            <el-form-item class='edit-form w100' label="收货地址">
                <span>{{Form.AgentConsignee}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="收货人及联系方式">
                <span>{{Form.Consignee}}{{Form.ConsigneeTel}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="寄送方式">
                <span>{{Form.SendModeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="支付方式">
                <span>{{Form.PayModeName}}</span>
            </el-form-item>
            <el-form ref="form2" label-width="180px" v-show="this.isList">
                <el-form-item label="出库情况" style="color:black;font-size: 18px;font-weight: bold">
                </el-form-item>
                <!--  {{this.Form.OutList.StockOutCode!=''}}-->
                <el-collapse accordion style="width: 80%;margin: -45px 205px 20px">
                    <el-collapse-item v-for="(item,index) in Form.OutList" :title="'出库单号'+(index+1)" :name="index">
                        <el-form-item label="出库单号">
                            <span>{{item.StockOutCode}}</span>
                        </el-form-item>
                        <el-form-item label="收货状态">
                            <span>{{item.ReceivingStatusName}}</span>
                        </el-form-item>
                        <el-form-item label="商品" v-show="item.ListGoods!=''" style="width:700px">
                            <el-table :data="item.ListGoods" border style="width: 80%;  margin-left: 25px;">
                                <el-table-column prop="ProName" label="名称">
                                </el-table-column>
                                <!--<el-table-column prop="SendNum" label="应发">
                                            </el-table-column>-->
                                <el-table-column prop="ProNum" label="实发">
                                </el-table-column>
                                <el-table-column prop="ReceiveNum" label="实收">
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                        <el-form-item label="赠品" v-show="item.GiftGoods!=''" style="width:700px">
                            <el-table :data="item.GiftGoods" border style="width: 80%;  margin-left: 25px;">
                                <el-table-column prop="ProName" label="名称">
                                </el-table-column>
                                <el-table-column prop="SendNum" label="应发">
                                </el-table-column>
                                <el-table-column prop="ProNum" label="实发">
                                </el-table-column>
                                <el-table-column prop="ReceiveNum" label="实收">
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                        <el-form-item label="实际发货时间">
                            <span v-if="item.StockOutTime!=''&&item.StockOutTime!=undefined">{{item.StockOutTime}}</span>
                            <span v-else>--</span>
                        </el-form-item>
                        <el-form-item label="实际签收时间">
                            <span v-if="item.SignTime!=''&&item.SignTime!=undefined">{{item.SignTime}}</span>
                            <span v-else>--</span>
                        </el-form-item>
                        <el-form-item label="快递或物流名称">
                            <span v-if="item.LogisticsName!=''&&item.LogisticsName!=undefined">{{item.LogisticsName}}</span>
                            <span v-else>--</span>
                        </el-form-item>
                        <el-form-item label="快递或物流单号">
                            <span v-if="item.LogisticsCode!=''&&item.LogisticsCode!=undefined">{{item.LogisticsCode}}</span>
                            <span v-else>--</span>
                        </el-form-item>
                        <el-form-item label="出库单备注">
                            <span v-if="item.Remark!=''&&item.Remark!=undefined">{{item.Remark}}</span>
                            <span v-else>--</span>
                        </el-form-item>
                    </el-collapse-item>

                </el-collapse>
            </el-form>
            <el-form-item class='edit-form' label="">
                <el-button :plain="true" type="info" @click="goBack()">我知道了</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import NProgress from 'nprogress'
import {
    ViewSendGoodsForBus
} from '@api/sendGoodsApi.js'
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';

module.exports = {
    data() {
        return {
            isList: false,
            Form: {}
        }
    },
    created: function() {

        if (this.$route.query.Id != undefined && this.$route.query.Sid != undefined && this.$route.query.Session != undefined) {

            let _session = util.getSessin();
            let para = {
                Sid: _session[0],
                Session: _session[1],
                Id: this.$route.query.Id
            };

            ViewSendGoodsForBus(para).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    let Data = res.data.Data;
                    this.Form = [];
                    this.Form = Data;
                    if (this.Form.OutList.length > 0) {
                        this.isList = true;
                    } else {
                        this.isList = false;
                    }
                }
            })
        }
    },
    methods: {
        goBack() {
            window.history.go(-1);
        }
    }
}
</script>
<style scoped>
span {
    margin-left: 25px;
}
</style>


// WEBPACK FOOTER //
// ViewSendGoodsForBus.vue?3dca98fd